export const PORTRAIT_ASPECT_RATIO = 9 / 16;
export const MIN_ZOOM = 1;
export const MAX_ZOOM = 3;
export const PREVIEW_MAX_DIMENSION = 1600;

export const clamp = (value: number, min: number, max: number) => Math.max(min, Math.min(max, value));

export const getBaseCropSize = (params: { naturalWidth: number; naturalHeight: number }) => {
  let height = params.naturalHeight;
  let width = height * PORTRAIT_ASPECT_RATIO;
  if (width > params.naturalWidth) {
    width = params.naturalWidth;
    height = width / PORTRAIT_ASPECT_RATIO;
  }
  return { width, height };
};

export const getCropSize = (params: { baseWidth: number; baseHeight: number; zoom: number }) => {
  const clampedZoom = clamp(params.zoom, MIN_ZOOM, MAX_ZOOM);
  return {
    width: params.baseWidth / clampedZoom,
    height: params.baseHeight / clampedZoom,
  };
};

export const clampPan = (params: {
  pan: { x: number; y: number };
  naturalWidth: number;
  naturalHeight: number;
  cropWidth: number;
  cropHeight: number;
}) => {
  const maxPanX = Math.max(0, (params.naturalWidth - params.cropWidth) / 2);
  const maxPanY = Math.max(0, (params.naturalHeight - params.cropHeight) / 2);
  return {
    x: clamp(params.pan.x, -maxPanX, maxPanX),
    y: clamp(params.pan.y, -maxPanY, maxPanY),
  };
};

export const getCropRect = (params: {
  naturalWidth: number;
  naturalHeight: number;
  cropWidth: number;
  cropHeight: number;
  panX: number;
  panY: number;
}) => {
  const centerX = params.naturalWidth / 2 + params.panX;
  const centerY = params.naturalHeight / 2 + params.panY;
  const x = clamp(centerX - params.cropWidth / 2, 0, params.naturalWidth - params.cropWidth);
  const y = clamp(centerY - params.cropHeight / 2, 0, params.naturalHeight - params.cropHeight);
  return { x, y, width: params.cropWidth, height: params.cropHeight };
};

export const getPerspectiveCorners = (params: { width: number; height: number; hTilt: number; vTilt: number }) => {
  const cx = params.width / 2;
  const cy = params.height / 2;

  const topWidthScale = 1 + params.hTilt * 0.4;
  const bottomWidthScale = 1 - params.hTilt * 0.4;
  const leftHeightScale = 1 + params.vTilt * 0.4;
  const rightHeightScale = 1 - params.vTilt * 0.4;

  const topLeftX = cx - (params.width * topWidthScale) / 2;
  const topLeftY = cy - (params.height * leftHeightScale) / 2;
  const topRightX = cx + (params.width * topWidthScale) / 2;
  const topRightY = cy - (params.height * rightHeightScale) / 2;
  const bottomRightX = cx + (params.width * bottomWidthScale) / 2;
  const bottomRightY = cy + (params.height * rightHeightScale) / 2;
  const bottomLeftX = cx - (params.width * bottomWidthScale) / 2;
  const bottomLeftY = cy + (params.height * leftHeightScale) / 2;

  return [
    { x: topLeftX, y: topLeftY },
    { x: topRightX, y: topRightY },
    { x: bottomRightX, y: bottomRightY },
    { x: bottomLeftX, y: bottomLeftY },
  ];
};
